import { Country } from '@/models/Country'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<Country>(Country, {
	namespaced: true
})
